import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, Card, IconButton, Tooltip } from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import {Delete, LinkRounded, Settings, VisibilityRounded } from '@material-ui/icons';
import DatasheetView from './DatasheetView';
import DatePicker from './DatePicker';
// import moment from 'moment';
// import Toggle from './Toggle';
import DropDown from './DropDown';
import moment from 'moment';
import OHSFormLink from './OHSFormLink';
import OHSQualSubform from './OHSQualSubform';
// import { activeGridFilterItemsSelector } from '@material-ui/data-grid';

export default class OHSAppointments extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {
            error: false,
            error_message: '',
            file_warning: '',
            page_state: 'init',
            page_sub_state: 'init',
            active_branches_array: [],
            active_appointments_array: [],
            required_appointments_array: [],
            required_appointments_drop_array: [],
            branch_users_array: [],
            selected_branch: '',
            selected_branch_description: '',
            selected_appointment_type: {branch_appointment_type_id:0},
            selected_employee: {id:''},
            selectedFile: null,
            appointment_date: '',
            qual_link: '',
            qual_obj: {id:0},
            writing: false,
            current_record: {}
        }
        this.state = this.initial_state;

        this.datasheetFieldSpecs_active = [
            { field: 'branch_appointment_type', headerName: 'OHS Role', width: 200},
            { field: 'employee_number', headerName: 'Empl.#', width: 90, sortable: false},
            { field: 'name', headerName: 'Appointee', width: 160},
            { field: 'job_title', headerName: 'Job Title', width: 160, sortable: false},
            { field: 'qualification_type', headerName: 'Certificate Linked to Appointment', width: 300, sortable: false},
            { field: 'expires', headerName: 'Cert. Expires?', width: 120, sortable: false,
            renderCell: (parms) => (
                (parms.row.cert_expires)&&
                <span style={{color: -moment().diff(parms.row.cert_expires,'days') < 1 ? '#FF0000' : -moment().diff(parms.row.cert_expires,'days') <= 30 ? '#FF9900' : ''}}>{parms.row.cert_expires}</span>
            )},
            { field: 'q_file_attachment', headerName: 'Certificate', width: 70, align:'center', sortable:false,
            renderCell: (parms) => (
                (parms.row.q_file_attachment==="YES")&&
                <IconButton
                    onClick={()=>this.viewDoc(parms.row,'cert')} 
                >
                    <Tooltip title="View OHS Certificate">
                        <VisibilityRounded/>
                    </Tooltip>
                </IconButton>
            )},
            { field: 'replace_link', headerName: 'Link to Cert.', width: 70, align:'center', sortable:false,
            renderCell: (parms) => (
                (parms.row.q_file_attachment==="YES"||parms.row.certificate_link_required!==0)&&
                <IconButton
                    onClick={()=>this.replaceLink(parms.row)} 
                >
                    <Tooltip title="Link OHS Certificate to this Appointment">
                        <LinkRounded />
                    </Tooltip>
                </IconButton>
            )},
            { field: 'appointment_date', headerName: 'Appointed?', width: 110, sortable: false},
            { field: 'file_attachment', headerName: 'Appointment Letter', width: 70, align:'center', sortable:false,
            renderCell: (parms) => (
                (parms.row.file_attachment===1)&&
                <IconButton
                    onClick={()=>this.viewDoc(parms.row,'apptmt')} 
                >
                    <Tooltip title="View Appointment Letter">
                        <VisibilityRounded />
                    </Tooltip>
                </IconButton>
            )}


        ]

        this.datasheetFieldSpecs2 = [
            { field: 'appoint', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.selectEmpl(parms)} 
                    color='primary'
                    variant='outlined'
                    // disabled={!this.state.search_ready}
                >
                    Appoint
                </Button>
            )},
            { field: 'id', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},     
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'id_number', headerName: 'ID Number', width: 130},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Store Code', width: 90, sortable:false},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125,sortable: false}

        ]

        this.input_fieldSpecs = [
            {field: "branch_appointment_type_id", headerName: "OHS Role", f_inputType:'dropdown', f_show:true, f_required:true},
            {field: "appointment_date", headerName: "Effective Date?", f_inputType:'datepicker', f_show:true, f_required:true}
            // {field: "description", headerName: "Description", f_inputType:'text', f_show:true, f_required:true,  f_maxLength: 500},
        ]
    }

    resolveBranchName = (store_code) => {
        return this.state.active_branches_array.find(branch => {
            return branch.store_code === store_code;
        }).branch
    }

    resolveAppointmentType = (id) => {
        return this.state.required_appointments_array.find(appt_type => {
            return appt_type.branch_appointment_type_id === Number(id)
        })
    }

    componentDidMount = () => {
        if (!this.state.active_branches_array.length) {
            Gserv.sendCommand('query_active_branches',this.props.gwt)
            .then(reply=>{
                // console.log('query_active_branches reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (query_active_branches) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                    console.log('error on return from Gserv (query_active_branches) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({active_branches_array:reply.Records,page_state:'ready'});
                }
            });
        }
    };
    
    resetMe = () => {
        let reset_state = this.initial_state;
        delete reset_state.active_branches_array; //Don't reset active_branches_array
        reset_state.page_state = 'ready';
        this.setState(reset_state);
    }

    handleChildUpdate = (update_obj) => {

        if (this.state.page_sub_state!=='replace link'){
            //Fresh appointment creation
            this.setState(update_obj);
        } else {
            //Link replacement only
            if (this.state.qual_link!==update_obj.qual_link){
                this.updateLink(update_obj.qual_link);
            } else {
                 this.setState({page_sub_state:'init'});
            }
        }

    }
   
    cancelCreate = () => {
        this.setState({
            page_sub_state: 'init',
            selected_appointment_type: {branch_appointment_type_id:0}, selected_employee: {id:''},
            file_warning: '',
            selectedFile: null,
            appointment_date: '',
            qual_link: '',
            qual_obj: {id:0}
        });
    }

    handleBranchSelect = (e) => {
        // console.log('e :>> ', e);
        if (e.value !== ''){
            this.setState({selected_branch:e.value, selected_branch_description: this.resolveBranchName(e.value)});
        } else {
            this.setState({selected_branch:'', selected_branch_description: ''});
        }
    }

    fetchOHSData = () => {

        if (this.state.selected_branch==='') {return}

        this.setState({page_state:'fetching branch data'});

        //async fetch branch ohs data...
        Gserv.sendCommand('query_ohs_appointments_for_branch_maintenance',this.props.gwt,{selected_branch : this.state.selected_branch})
        .then(ohs_data => {
            // console.log('query_ohs_appointments_for_branch reply :>> ', ohs_data);
            if (ohs_data.error){
                console.log('error on return from Gserv (query_ohs_appointments_for_branch_maintenance) :>> ', ohs_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (ohs_data.Result!=="Success"){
                console.log('error on return from Gserv (query_ohs_appointments_for_branch_maintenance) :>> ', ohs_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {

                //populate drop array async
                let drop_array = [];
                ohs_data.required_appointments.forEach(type => {
                    drop_array.push({id: type.branch_appointment_type_id, type_description: type.branch_appointment_type});
                })

                this.setState({
                    active_appointments_array: ohs_data.active_appointments,
                    required_appointments_array: ohs_data.required_appointments,
                    required_appointments_drop_array: drop_array,
                    page_state:'branch view'
                });
            }
        });
        
        // async query branch employees...
        Gserv.sendCommand('query_branch_employees',this.props.gwt,{selected_branch: this.state.selected_branch})
        .then(reply=>{
            // console.log('query_branch_employees reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_branch_employees) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_branch_employees) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState({branch_users_array:reply.Records});
            }
        });

    }

    handleTypeUpdate = (e) => {
        // console.log('e :>> ', e);
        if (e.value !== ''){
            this.setState({selected_appointment_type: this.resolveAppointmentType(e.value),page_sub_state: 'select employee'});
        } else {
            this.setState({selected_appointment_type: {branch_appointment_type_id:0}, page_sub_state:'select type'});
        }
    }

    selectEmpl = (employee) => {
        this.setState({selected_employee:employee.row,page_sub_state:'app detail'})
    }

    onFileChange = event => {
        // console.log('onFileChange called');
        // Update the state
        if (event.target.files[0]){
            // console.log('event.target.files[0] :>> ', event.target.files[0]);
            if (event.target.files[0].size>2048000){
                this.setState({selectedFile:null,file_warning:'The file selected is larger that 2mb. Please select a smaller file for upload.'});  
            } else if (event.target.files[0].name.slice(-4)!=='.pdf'&&event.target.files[0].name.slice(-4)!=='.PDF'){
                this.setState({selectedFile:null,file_warning:'The selected file does not appear to be a Portable Document Format (PDF) file. Please select .pdf file for upload.'});  
            } else {
                this.setState({selectedFile: event.target.files[0],file_warning:''});
            }
        } else {
            this.setState({selectedFile:null, file_warning:''});
        }
    };
    
    clearFile = () => {
        document.getElementById('file-upload-obj').value = null;
        this.setState({selectedFile: null});
    };

    clearQualLink = () => {
        this.setState({ qual_link: '',
        qual_obj: {id:0}});
    };

    handleApptDateChange = (update_obj) => {
        // console.log('update_obj :>> ', update_obj);
        this.setState({appointment_date: update_obj.value})
    };

    viewDoc = (record,doc_type) => {
        // console.log('record :>> ', record);
        // console.log('doc_type :>> ', doc_type);

        Gserv.sendCommand('query_qualification_attachment',this.props.gwt,{
            file_key: doc_type==='apptmt' ? record.file_key : record.q_file_key,
            doc_type: doc_type,
            store_code: this.state.selected_branch
        })
        .then(file_url => {
            // console.log('file_url obj returned :>> ', file_url);
            if (file_url.error){
                console.log('error on return from Gserv (query_qualification_attachment) :>> ', file_url);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (file_url.Result!=="Success"&&file_url.statusCode!==204){
                console.log('error on return from Gserv (query_qualification_attachment) :>> ', file_url);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                window.open(file_url.Url, '_blank', 'noopener,noreferrer');
            }
        }); 
    }

    submitMe = () => {
        this.setState({writing:true});

        const payload = {
            store_code : this.state.selected_branch,
            branch_appointment_type_id : this.state.selected_appointment_type.branch_appointment_type_id,
            employee_number : this.state.selected_employee.id,
            appointment_date : this.state.appointment_date,
            qualification_id_link : this.state.qual_link? this.state.qual_link : null
        }

        const formData = new FormData();
        formData.append("asFile",this.state.selectedFile,this.state.selectedFile.name);
        formData.append("payload",JSON.stringify(payload));

        Gserv.sendForm('create_ohs_appointment',this.props.gwt,formData)
        .then(reply=>{
            // console.log('reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (create_ohs_appointment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else if (reply.Result==='Failed' && reply.Message.toString().includes('status code 409')){
                this.setState({error:true,error_message:"This employee is already appointed in the selected role. Please either delete the existing appointment, or select another employee or OHS role.",writing:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (create_ohs_appointment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else {

                this.setState({
                    page_state: 'fetching branch data',
                    page_sub_state: 'init',
                    selected_appointment_type: {branch_appointment_type_id:0}, selected_employee: {id:''},
                    file_warning: '',
                    selectedFile: null,
                    appointment_date: '',
                    qual_link: '',
                    qual_obj: {id:0},
                    writing: false
                });
                
                //async fetch branch ohs data...
                Gserv.sendCommand('query_ohs_appointments_for_branch_maintenance',this.props.gwt,{selected_branch : this.state.selected_branch})
                .then(ohs_data => {
                    // console.log('query_ohs_appointments_for_branch reply :>> ', ohs_data);
                    if (ohs_data.error){
                        console.log('error on return from Gserv (query_ohs_appointments_for_branch_maintenance) :>> ', ohs_data);
                        this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                    } else if (ohs_data.Result!=="Success"){
                        console.log('error on return from Gserv (query_ohs_appointments_for_branch_maintenance) :>> ', ohs_data);
                        this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                    } else {
                        this.setState({active_appointments_array: ohs_data.active_appointments, page_state:'branch view'});
                    }
                });
                
            }
        });
    }

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);
        // this.setState({show_dialogue:true});

        if (!this.props.admin){
            window.alert("Only authorised administrators are able to delete OHS appointments.");
            return;
        }

        if (window.confirm("This function will delete this appointment in its entirey - this cannot be undone. Are you sure you wish to proceed?")){

            this.setState({deleting:true,querying:true});
            Gserv.sendCommand('delete_ohs_appointment',this.props.gwt,{
                branch_appointment_id: record.id
            })
            .then(reply => {
                // console.log('delete reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (delete_ohs_appointment) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (delete_ohs_appointment) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {

                    this.setState({
                        page_state: 'fetching branch data',
                        page_sub_state: 'init',
                        selected_appointment_type: {branch_appointment_type_id:0}, selected_employee: {id:''},
                        file_warning: '',
                        selectedFile: null,
                        appointment_date: '',
                        qual_link: '',
                        qual_obj: {id:0},
                        writing: false
                    });
                    
                    //async fetch branch ohs data...
                    Gserv.sendCommand('query_ohs_appointments_for_branch_maintenance',this.props.gwt,{selected_branch : this.state.selected_branch})
                    .then(ohs_data => {
                        // console.log('query_ohs_appointments_for_branch reply :>> ', ohs_data);
                        if (ohs_data.error){
                            console.log('error on return from Gserv (query_ohs_appointments_for_branch_maintenance) :>> ', ohs_data);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else if (ohs_data.Result!=="Success"){
                            console.log('error on return from Gserv (query_ohs_appointments_for_branch_maintenance) :>> ', ohs_data);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else {
                            this.setState({active_appointments_array: ohs_data.active_appointments, page_state:'branch view'});
                        }
                    });

                }
            });
        }
    }

    replaceLink = (record) => {
        // console.log('record :>> ', record);
        this.setState({selected_employee: {id: record.employee_number}, selected_appointment_type: {branch_appointment_type_id: record.branch_appointment_type_id},qual_link:record.qualification_id_link, current_record: record, page_sub_state:'replace link'});
    }

    updateLink = (qual_link) => {
        this.setState({writing:true});

        const payload = {
            branch_appointment_id : this.state.current_record.id,
            new_qual_link_id : qual_link
        }

        Gserv.sendForm('update_ohs_appointment_qual_link',this.props.gwt,payload)
        .then(reply=>{
            // console.log('reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (update_ohs_appointment_qual_link) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (update_ohs_appointment_qual_link) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else {

                this.setState({
                    page_state: 'fetching branch data',
                    page_sub_state: 'init',
                    selected_appointment_type: {branch_appointment_type_id:0}, selected_employee: {id:''},
                    file_warning: '',
                    selectedFile: null,
                    appointment_date: '',
                    qual_link: '',
                    qual_obj: {id:0},
                    writing: false
                });
                
                //async fetch branch ohs data...
                Gserv.sendCommand('query_ohs_appointments_for_branch_maintenance',this.props.gwt,{selected_branch : this.state.selected_branch})
                .then(ohs_data => {
                    // console.log('query_ohs_appointments_for_branch reply :>> ', ohs_data);
                    if (ohs_data.error){
                        console.log('error on return from Gserv (query_ohs_appointments_for_branch_maintenance) :>> ', ohs_data);
                        this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                    } else if (ohs_data.Result!=="Success"){
                        console.log('error on return from Gserv (query_ohs_appointments_for_branch_maintenance) :>> ', ohs_data);
                        this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                    } else {
                        this.setState({active_appointments_array: ohs_data.active_appointments, page_state:'branch view'});
                    }
                });
                
            }
        });
    }

    render() {return(
        <Grid
            container
            direction='column'
        >
            <Grid item>
                {(this.state.page_state==='init'||this.state.page_state==='ready')&&
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1025
                    }}
                >
                    <Typography color='primary' style={{paddingTop:'15px', paddingBottom: '10px'}}>
                        Maintain OHS Appointments
                    </Typography>

                    <Card
                        elevation={2}
                        style={{marginTop:'0px'}}
                    >
                        <Grid 
                            container 
                            direction='row'
                            justifyContent='center'
                            alignItems='center'
                            style={{padding:'10px', paddingLeft:'50px',marginBottom:15}}
                        >

                            {this.state.page_state==='init'&&!this.state.error&&
                            <div style={{color:'lightgray',marginTop:15}}>
                                <Settings className='icn-spinner' /> <small><i>loading...</i></small>
                            </div>}

                            {this.state.page_state==='ready'&&
                            <DropDown 
                                fieldMap={{
                                    field: "selected_branch",
                                    headerName: "Select Branch",f_inputType:'dropdown',
                                    f_show:true,
                                    f_required:true
                                }}
                                setField={this.handleBranchSelect}
                                // editRecord={this.state.filters}
                                listArray={this.state.active_branches_array}
                                disabled={this.state.page_state !== 'ready'}
                            />}

                        </Grid>
                    </Card>

                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        style={{marginLeft:'10px',marginTop:'15px',marginBottom:'15px'}}
                        disabled={(this.state.selected_branch==='')}
                        onClick={this.fetchOHSData}
                    >
                        Maintain OHS Appointments for this branch
                    </Button>

                </Paper>}

                {this.state.page_state==='fetching branch data'&&!this.state.error&&
                <div>
                    <Settings className='icn-spinner' /> Querying OHS Appointments for Branch: <b>{this.state.selected_branch}</b> 
                </div>}

                {this.state.page_state==='branch view'&&!this.state.error&&
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1025
                    }}
                >
                    <Paper
                        elevation={3}
                        style={{
                            width:'100%',
                            paddingTop: 15,
                            // paddingBottom: 15,
                            marginBottom: 2
                        }}
                    >
                        {this.state.page_sub_state==='init'&&
                        <Grid>
                            <Button
                                variant='contained'
                                color='primary'
                                // type='submit'
                                style={{marginLeft:'10px',marginTop:'15px',marginBottom:'15px'}}
                                disabled={(!this.state.branch_users_array.length)}
                                onClick={() => this.setState({page_sub_state:'select type'})}
                            >
                                Create New OHS Appointment
                            </Button>
                            
                            <Button
                                variant='outlined'
                                color='primary'
                                // type='submit'
                                style={{marginLeft:'10px',marginTop:'15px',marginBottom:'15px'}}
                                disabled={(!this.state.branch_users_array.length)}
                                onClick={this.resetMe}
                            >
                                Select Another Branch
                            </Button>
                        </Grid>}

                        {this.state.page_sub_state!=='init'&&
                        <Card
                            elevation={2}
                            style={{padding:'10px'}}
                        >
                            <Grid 
                                container 
                                direction='row'
                                justifyContent='center'
                                alignItems='center'
                            >
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    {this.state.page_sub_state!=='replace link'&&
                                    <Typography color='primary'>
                                        Create New OHS Appointment for branch: <b>{this.state.selected_branch_description}</b>
                                    </Typography>}

                                    {this.state.page_sub_state==='replace link'&&    
                                    <Typography color='primary'>
                                        Link a new OHS certificate to appointment of #{this.state.current_record.employee_number} <b>{this.state.current_record.name}</b><br/>as <b>{this.state.current_record.branch_appointment_type}</b> for branch <b>{this.state.selected_branch_description}</b>
                                    </Typography>}

                                </Grid>
                                <Grid item xs={2}>
                                    <Button 
                                        variant='outlined'
                                        size='small'
                                        color='primary'
                                        onClick={this.cancelCreate}
                                        disabled={this.state.writing}
                                    >Cancel</Button>
                                </Grid>
                            </Grid>
                            
                        </Card>}
                    </Paper>

                    {this.state.page_sub_state==='init'&&        
                    <div>
                        <Card
                            elevation={2}
                            style={{padding:'10px'}}
                        >
                            <Typography color='primary' style={{paddingTop:'10px'}}>
                                OHS Appointments for branch: <b>{this.state.selected_branch_description}</b>
                            </Typography>
                        </Card>

                        {this.state.active_appointments_array.length!==0&&
                        <div>
                            <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Current OHS Appointments</Typography>

                            {/* active apptms datagrid */}
                            <DatasheetView 
                                dataset={this.state.active_appointments_array}
                                fieldspecs={this.datasheetFieldSpecs_active}
                                delete={true}
                                edit={false}
                                handleDelete={this.handleDelete}
                                handleEdit={null}
                                // loading={this.state.querying}
                                deleteHeaderName={'Delete Appointment'}
                                // pagesize={10}
                                // height={500}
                            />
                        </div>}

                        {!this.state.active_appointments_array.length&&
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>There are no OHS appointments for this branch yet</Typography>}

                    </div>}

                    {this.state.page_sub_state!=='init'&&this.state.page_sub_state!=='app detail'&&this.state.page_sub_state!=='writing app'&&
                    <div>

                        {this.state.page_sub_state==='select type'&&
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Select OHS role for appointment</Typography>}

                        {this.state.page_sub_state!=='replace link'&&
                        <div style={{padding:15}}>    
                            <DropDown fieldMap={this.input_fieldSpecs[0]} setField={this.handleTypeUpdate} listArray={this.state.required_appointments_drop_array} disabled={false}/>
                        </div>}

                        {this.state.page_sub_state==='select employee'&&
                        <div>
                            <hr/>    
                            <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Please select an individual employee to appoint</Typography>

                            <DatasheetView 
                                dataset={this.state.branch_users_array}
                                fieldspecs={this.datasheetFieldSpecs2}
                                delete={false}
                                edit={false}
                                handleDelete={null}
                                handleEdit={null}
                                // loading={this.state.searching}
                                deleteHeaderName={'Delete'}
                                height={350}
                            />
                        </div>}
                   
                    </div>}

                    {/* Further App Details & File Uploads */}
                    {(this.state.page_sub_state==='app detail')&&
                    <div>

                        <Typography style={{backgroundColor:'lightgray',padding:'10px', marginBottom:15}}>OHS Appointment Details & Documents</Typography>

                        <Typography style={{marginBottom:15}}>
                        #{this.state.selected_employee.id} <b>{this.state.selected_employee.name}</b> ({this.state.selected_employee.job_title}) will be appointed as a <b>{this.state.selected_appointment_type.branch_appointment_type}</b> for the above branch.
                        </Typography>

                        <hr/>

                        {this.state.selected_appointment_type.certificate_link_required===1&&!this.state.qual_link&&!this.state.qual_obj.skipped&&
                        <div style={{textAlign:'center'}}>
                            <OHSQualSubform 
                                employee_number={this.state.selected_employee.id}
                                employee_name={this.state.selected_employee.name}
                                gwt={this.props.gwt}
                                setParentState={this.handleChildUpdate}
                                allow_skip={true}
                            />
                        </div>} 

                        {this.state.qual_link!==''&&
                        <div>
                        <Typography>    
                            Certification: <b>{this.state.qual_obj.qualification_type}</b> : {this.state.qual_obj.description} (Valid until <b>{this.state.qual_obj.expires}</b>)
                            <IconButton
                                onClick={this.clearQualLink}
                                disabled={this.state.writing}
                            >
                                <Delete/>
                            </IconButton>    
                        </Typography>
                        <hr/>
                        </div>}
                        
                        {(this.state.selected_appointment_type.certificate_link_required===0 || (this.state.qual_link||this.state.qual_obj.skipped))&&
                        <div>
                            <Typography style={{marginBottom:15}}>
                            Appointment letter and form templates are available for download here: <OHSFormLink form={this.state.selected_appointment_type.form_prescribed} title={'Appointment Letter and Form Pack (' + this.state.selected_appointment_type.form_prescribed + ')'}/>    
                            </Typography>

                            <Grid 
                                container
                                direction='column'
                                alignContent='center'
                                justifyContent='center'
                                style={{height:'100%'}}
                            >
                                <input
                                    accept="application/pdf"
                                    style={{ display: 'none' }}
                                    id="file-upload-obj"
                                    multiple={false}
                                    type="file"
                                    onChange={this.onFileChange}
                                    disabled={this.state.selectedFile? true : false || (this.state.selected_appointment_type.certificate_link_required===1 && (!this.state.qual_link&&!this.state.qual_obj.skipped))}
                                />
                                <label htmlFor="file-upload-obj">
                                    <Button 
                                        variant="contained"
                                        color='primary'
                                        component="span"
                                        disabled={this.state.selectedFile? true : false || (this.state.selected_appointment_type.certificate_link_required===1 && (!this.state.qual_link&&!this.state.qual_obj.skipped))}
                                        style={{marginBottom:15}}
                                    >
                                        Upload Signed OHS Appointment Letter
                                    </Button>
                                </label>

                                {this.state.selectedFile&&
                                <Typography>
                                    {this.state.selectedFile.name}
                                    <IconButton
                                        onClick={this.clearFile}
                                        disabled={this.state.writing}
                                    >
                                        <Delete/>
                                    </IconButton>
                                </Typography>}

                                {this.state.file_warning&&
                                <Typography color='secondary' style={{maxWidth:600, textAlign:'left'}}><i>{this.state.file_warning} <b>This file will not be uploaded</b>.</i></Typography>}

                            </Grid>

                            <Grid 
                                container              
                                direction='row'
                                alignContent='center'
                                justifyContent='center'
                            >
                                <div style={{width:'20%'}}>
                                    <DatePicker fieldMap={this.input_fieldSpecs[1]} setField={this.handleApptDateChange} disabled={this.state.writing}/>
                                </div>
                            </Grid>

                            <Button
                                variant='contained'
                                color='primary'
                                // type='submit'
                                style={{marginLeft:'10px',marginTop:'15px',marginBottom:'15px'}}
                                disabled={!this.state.selectedFile||!this.state.appointment_date||(this.state.selected_appointment_type.certificate_link_required===1 && (!this.state.qual_link&&!this.state.qual_obj.skipped))||this.state.writing}
                                onClick={this.submitMe}
                            >
                                Create OHS Appointment
                            </Button>

                            {this.state.writing&&!this.state.error&&
                            <Typography style={{padding:5}}>
                                <Settings className='icn-spinner' /> <i>Creating OHS appointment...</i> 
                            </Typography>}

                        </div>}
                        
                    </div>}

                    {/* Specialised form to replace link only  */}
                    {this.state.page_sub_state==='replace link'&&
                    <div>

                        {!this.state.writing&&
                        <OHSQualSubform 
                            employee_number={this.state.selected_employee.id}
                            employee_name={this.state.current_record.name}
                            gwt={this.props.gwt}
                            setParentState={this.handleChildUpdate}
                            allow_skip={false}
                        />}

                        {this.state.writing&&!this.state.error&&
                        <Typography style={{padding:5}}>
                            <Settings className='icn-spinner' /> <i>Updating OHS certificate link...</i> 
                        </Typography>}
                    </div>}

                </Paper>}

            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1200,maxWidth:1200, textAlign:'center',marginBottom:'15px'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    );}
    
}